import React, {useEffect, useState} from 'react';
import {FilterIcon} from './actionIcons';
import {withFocusOnClick} from '../../utils/focusUtils';

const FILTERS_BREAKPOINT = 768;

/**
 * Layout padrao para telas de consulta (list):
 * preenche a altura da janela, tabela com rolagem e rodape (totais) fixo.
 */
const ListPageLayout = ({tableWidth = 900, header, filters, footer, children}) => {
    const widthValue = typeof tableWidth === 'number' ? `${tableWidth}px` : tableWidth;

    const [isCompact, setIsCompact] = useState(() => window.innerWidth < FILTERS_BREAKPOINT);
    const [filtersVisible, setFiltersVisible] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${FILTERS_BREAKPOINT - 1}px)`);
        const updateCompact = () => {
            const compact = mediaQuery.matches;
            setIsCompact(compact);
            if (compact) {
                setFiltersVisible(false);
            }
        };
        updateCompact();
        mediaQuery.addEventListener('change', updateCompact);
        return () => mediaQuery.removeEventListener('change', updateCompact);
    }, []);

    const showFiltersPanel = !isCompact || filtersVisible;

    return (
        <div
            className="list-page"
            style={{'--list-table-width': widthValue}}
        >
            {header ? <div className="list-page__header">{header}</div> : null}
            {filters ? (
                <div className="list-page__filters-section">
                    {isCompact ? (
                        <div className="list-page-filters-toggle-bar">
                            <span className="list-page-filters-toggle__label">Filtros</span>
                            <button
                                type="button"
                                className={`list-page-filters-toggle${filtersVisible ? ' list-page-filters-toggle--active' : ''}`}
                                aria-expanded={filtersVisible}
                                aria-pressed={filtersVisible}
                                aria-label={filtersVisible ? 'Ocultar filtros' : 'Exibir filtros'}
                                title={filtersVisible ? 'Ocultar filtros' : 'Exibir filtros'}
                                onClick={withFocusOnClick(() => setFiltersVisible((visible) => !visible))}
                            >
                                <span className="list-page-filters-toggle__icon" aria-hidden="true">
                                    <FilterIcon/>
                                </span>
                            </button>
                        </div>
                    ) : null}
                    <div
                        className={`list-page__filters list-page-filters${showFiltersPanel ? '' : ' list-page-filters-panel--collapsed'}`}
                        hidden={!showFiltersPanel}
                    >
                        {filters}
                    </div>
                </div>
            ) : null}
            <div className="list-page__table-wrap">{children}</div>
            {footer ? <div className="list-page__footer">{footer}</div> : null}
        </div>
    );
};

export default ListPageLayout;
